import { Component, Input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzImageModule } from 'ng-zorro-antd/image';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { EventModel } from '../../models';
import { environment } from '@env/environment';
import { PriceFormatterPipe } from '../../utils';
import { ApiService } from '../../services';
import { AuthStateService } from '@hypenation/auth';
import { HttpResponse } from '@angular/common/http';
import { FilesService } from '@hypenation/shared';

@Component({
  selector: 'hypenation-tickets-event-card',
  standalone: true,
  imports: [CommonModule, NzIconModule, NzImageModule, PriceFormatterPipe],
  templateUrl: './event-card.component.html',
  styleUrl: './event-card.component.css',
})
export class EventCardComponent {
  apiUrl: string = environment.apiUrl;
  fileDownloadUrl: string = environment.fileDownloadUrl;
  eventImageUrl: string = '';
  // TODO: Uncomment when wishlist functionality is finalized
  // isInWishlist = signal<boolean>(false);
  // wishlistLoading = signal<boolean>(false);
  // wishlistItemUid = signal<string | null>(null);

  private _event!: EventModel;
  @Input()
  set event(value: EventModel) {
    this._event = value;
    if (value?.imageFileName) {
      this.loadImageUrl(value.imageFileName);
    }
  }
  get event(): EventModel {
    return this._event;
  }
  // TODO: Uncomment when wishlist functionality is finalized
  // @Input() initialWishlistItemUid?: string; // Optional: if item is already in wishlist

  constructor(
    private readonly _apiService: ApiService,
    private readonly _authStateService: AuthStateService,
    private readonly _notification: NzNotificationService,
    private readonly _router: Router,
    private readonly _filesService: FilesService
  ) {
    // TODO: Uncomment when wishlist functionality is finalized
    // // Check if item is already in wishlist
    // if (this.initialWishlistItemUid) {
    //   this.isInWishlist.set(true);
    //   this.wishlistItemUid.set(this.initialWishlistItemUid);
    // }
  }

  private loadImageUrl(fileName: string): void {
    this._filesService.getFileDownloadUrl(fileName).subscribe({
      next: (url) => {
        this.eventImageUrl = url;
      },
      error: () => {
        this.eventImageUrl = 'assets/placeholder.jpg';
      },
    });
  }

  // TODO: Uncomment when wishlist functionality is finalized
  // public toggleWishlist(e: Event): void {
  //   e.stopPropagation();
  //   e.preventDefault();

  //   // Check if user is authenticated
  //   if (!this._authStateService.isAuthenticated()) {
  //     // Redirect to login with returnUrl
  //     const currentUrl = this._router.url;
  //     this._router.navigate(['/login'], {
  //       queryParams: { returnUrl: currentUrl },
  //     });
  //     return;
  //   }

  //   if (this.isInWishlist()) {
  //     this.removeFromWishlist();
  //   } else {
  //     this.addToWishlist();
  //   }
  // }

  // private addToWishlist(): void {
  //   this.wishlistLoading.set(true);
  //   this._apiService.addToWishlist(this.event.uid).subscribe({
  //     next: (res: HttpResponse<any>) => {
  //       if (res.body?.uid) {
  //         this.wishlistItemUid.set(res.body.uid);
  //       }
  //       this.isInWishlist.set(true);
  //       this._notification.success(
  //         'Added to Wishlist',
  //         `${this.event.name} has been added to your wishlist.`
  //       );
  //       this.wishlistLoading.set(false);
  //     },
  //     error: (err) => {
  //       console.error('Add to wishlist error:', err);
  //       this._notification.error(
  //         'Failed to Add',
  //         'Failed to add item to wishlist. Please try again.'
  //       );
  //       this.wishlistLoading.set(false);
  //     },
  //   });
  // }

  // private removeFromWishlist(): void {
  //   const uid = this.wishlistItemUid();
  //   if (!uid) return;

  //   this.wishlistLoading.set(true);
  //   this._apiService.removeFromWishlist(uid).subscribe({
  //     next: () => {
  //       this.isInWishlist.set(false);
  //       this.wishlistItemUid.set(null);
  //       this._notification.success(
  //         'Removed from Wishlist',
  //         `${this.event.name} has been removed from your wishlist.`
  //       );
  //       this.wishlistLoading.set(false);
  //     },
  //     error: (err) => {
  //       console.error('Remove from wishlist error:', err);
  //       this._notification.error(
  //         'Failed to Remove',
  //         'Failed to remove item from wishlist. Please try again.'
  //       );
  //       this.wishlistLoading.set(false);
  //     },
  //   });
  // }
}
